import { Box, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { PASSWORD_MIN_LENGTH } from "lib/auth/password";
import { formatInteger } from "utils/formatting";

const PASSWORD_REQUIREMENTS = [
  `Use at least ${formatInteger(PASSWORD_MIN_LENGTH)} characters.`,
  "Use at least one letter and one number.",
  "Don’t use something too similar to your email address.",
  "Don’t use a commonly used password.",
];

export default function PasswordRequirements() {
  return (
    <Box mt={3} fontSize="xs" color="gray.500">
      <Text fontWeight={500}>Password requirements</Text>

      <UnorderedList m={0} pl={4}>
        {PASSWORD_REQUIREMENTS.map((requirement) => (
          <ListItem key={requirement}>{requirement}</ListItem>
        ))}
      </UnorderedList>
    </Box>
  );
}
